/* eslint-disable */
import { ConfiguratorDataApiParameter, ConfiguratorResult, getConfiguratorProducts } from "@bToC/Services/ConfiguratorService";
import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { result } from "lodash";

type GetConfiguratorDataParameter = {
    onError?: (error: string) => void;
} & ConfiguratorDataApiParameter &
    HasOnSuccess<ConfiguratorDataApiParameter>;

type GetConfiguratorDataResult = {
    configuratorDataResult: ConfiguratorResult;
}

type HandlerType = ApiHandler<GetConfiguratorDataParameter, GetConfiguratorDataResult>;

export const PopulateApiParameter: HandlerType = props => {
    throwErrorIfTesting();

    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    const result = await getConfiguratorProducts(props.apiParameter.CID ?? "");
    if (result.successful) {        
        props.apiResult.configuratorDataResult = result.result;
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiParameter);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const getConfiguratorData = createHandlerChainRunner(chain, "GetConfiguratorData");
export default getConfiguratorData;
